import { useContext, useEffect } from 'react';
import { boardTemplatePickerContext } from '../context/boardTemplatePickerContext';
import { DefaultTemplate, SimpleTemplate, Template } from '../templateTypes';

type Props = {
    enabled: boolean;
    fallbackTemplate: Template | SimpleTemplate | DefaultTemplate | undefined;
};

/**
 * Hook to automatically select template based on the following rule
 * - Reselect the last selected template ID if it exists
 * - Otherwise, select the first template in the provided list
 */
export default ({ enabled, fallbackTemplate }: Props) => {
    const { selectTemplate, prevSelectedTemplateIdRef } = useContext(boardTemplatePickerContext);

    useEffect(() => {
        if (!enabled) return;

        if (prevSelectedTemplateIdRef.current) {
            selectTemplate(prevSelectedTemplateIdRef.current);
            return;
        }

        if (fallbackTemplate) {
            selectTemplate(fallbackTemplate.id);
        }
    }, [enabled]);
};
